import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type { ApiResponseRouterEntityList } from "../../../shared/types/api";

export class CompanyRouterApiService {
  async getRouters(companyId: number): Promise<ApiResponseRouterEntityList> {
    const response = await httpClient.get<ApiResponseRouterEntityList>(
      NEW_API_ENDPOINTS.companyRouterController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "라우터를 가져오지 못했습니다.");
    }

    return response.data;
  }
}

export const companyRouterApiService = new CompanyRouterApiService();